﻿export { Identify };
import VectorSource from 'ol/source/Vector.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import TileLayer from 'ol/layer/Tile.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Draw, {
    createBox,
    createRegularPolygon,
} from 'ol/interaction/Draw';

/**
 * Class Identify
 */
const Identify = function () {

	// Define this
    var myIdentify = this;

    var drawPointNewgeomidentify = null;

    var layerIDhash = "";

    var hashlayerNameidentify = {};
    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Layer found
    this._layerFeatureFound = {};

    // Array column expand
    this._columnDefArrayExpand = {};

    // featuresArray
    this.featuresArray = [];

    this.countTotalFeatures = 0;

    this.VectorPointIdentify = null;

    this.layersToHighligth = [];

    // style
    this._styleNetworkDefault =
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.8)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.8)',
                width: 5
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        });

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------
    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    this.removeInteractionMap = function () {

        myIdentify._mapSgs.map.removeLayer(myIdentify.VectorPointIdentify);

        myIdentify._mapSgs.map.removeInteraction(drawPointNewgeomidentify);

        myIdentify._mapSgs.map.on('singleclick', async (e) => { await myIdentify._mapSgs.tooltips.BuildInfoTooltips(e); });

    }

    /**
     * Execute identifier point.
     * Get all feature in this point
     * @param {event} e, event
     */
    this.BuildInfoIndentify = function (Type) {

        var coordinatesIdentify = "";

        myIdentify._mapSgs.map.removeLayer(myIdentify.VectorPointIdentify);

        myIdentify._mapSgs.map.un('singleclick', myIdentify._mapSgs.tooltips.BuildInfoTooltips);

        var source = new VectorSource({ wrapX: false });

        myIdentify.VectorPointIdentify = new VectorLayer({
            source: source,
            style: new Style({
                fill: new Fill({
                    color: 'rgba(252, 3, 3, 10)'
                }),
                stroke: new Stroke({
                    color: 'rgba(252, 3, 3, 10)',
                    width: 7
                }),
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({
                        color: 'rgba(252, 3, 3, 10)'
                    })
                })
            }),
        });

        myIdentify._mapSgs.map.addLayer(myIdentify.VectorPointIdentify);

        drawPointNewgeomidentify = new Draw({
            source: source,
            type: Type
        });

        myIdentify._mapSgs.map.addInteraction(drawPointNewgeomidentify);

        drawPointNewgeomidentify.on('drawend', function (e)
        {

            myIdentify.countTotalFeatures = 0;

            myIdentify.layersToHighligth = [];

            myIdentify._mapSgs.layerHighlightOverlay.getSource().clear();

            $('#offcanvas-search-result-network-table-zone div').remove();

            coordinatesIdentify = e.target.sketchCoords_;

            myIdentify._mapSgs.map.removeInteraction(drawPointNewgeomidentify);

            var layerName = "";

            $('#offcanvas-map-spinner').removeClass('ol-hidden');

            var onlyVisible =  myIdentify._mapSgs._utility.GetPropertyInfoInConfigArray(myIdentify._mapSgs._settings.configurationInfo.propertyInfo, "IDENTIFY", "LAYERS", "JUST_LAYERS_VISIBLE").value;

            setTimeout(
                function () {

                    for (var i = 0; i < myIdentify._mapSgs.map.getLayers().array_.length; i++) {

                        if (onlyVisible.toLowerCase() == "true") {

                            if (myIdentify._mapSgs.map.getLayers().array_[i].state_.visible) {

                                if (myIdentify._mapSgs.map.getLayers().array_[i].values_.source.params_) {

                                    layerName = myIdentify._mapSgs.map.getLayers().array_[i].values_.source.params_.LAYERS

                                    if (layerName.split(':')[1] != 'FREGUESIA') {

                                        var columnGeom = myIdentify._mapSgs._settings._mapSettings.tree_map.dict_layer_info[app.sgs.Map.map.getLayers().array_[i].values_.gpId].layer_info

                                        var cql_filterIntersect = 'DWITHIN(' + columnGeom.geomColumnName + ', POINT(' + coordinatesIdentify[0] + ' ' + coordinatesIdentify[1] + '), 0.00010 , meters)';

                                        hashlayerNameidentify[columnGeom.id] = columnGeom;

                                        myIdentify.getAllObjectsonIntersect(layerName, cql_filterIntersect, columnGeom.geoserver, columnGeom.id);

                                    }
                                }
                            }

                        } else {

                            if (myIdentify._mapSgs.map.getLayers().array_[i].values_.source.params_) {

                                layerName = myIdentify._mapSgs.map.getLayers().array_[i].values_.source.params_.LAYERS

                                if (layerName.split(':')[1] != 'FREGUESIA') {

                                    var columnGeom = myIdentify._mapSgs._settings._mapSettings.tree_map.dict_layer_info[app.sgs.Map.map.getLayers().array_[i].values_.gpId].layer_info

                                    var cql_filterIntersect = 'DWITHIN(' + columnGeom.geomColumnName + ', POINT(' + coordinatesIdentify[0] + ' ' + coordinatesIdentify[1] + '), 0.00010 , meters)';

                                    hashlayerNameidentify[columnGeom.id] = columnGeom;

                                    myIdentify.getAllObjectsonIntersect(layerName, cql_filterIntersect, columnGeom.geoserver, columnGeom.id);

                                }
                            }

                        }

                    }

                }, 100);

            setTimeout(
                function () {
                    $('#offcanvas-map-spinner').addClass('ol-hidden');

                    for (var i = 0; i < myIdentify.layersToHighligth.length; i++) {
                        myIdentify._mapSgs.featureToHighLight.push(myIdentify.layersToHighligth[i]);
                    }

                    myIdentify._mapSgs.featureToHighLight.getArray()[myIdentify._mapSgs.featureToHighLight.getArray().length - 1].setStyle(myIdentify._styleNetworkDefault);

                    myIdentify._mapSgs.map.getView().fit(myIdentify._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myIdentify._mapSgs.map.getSize() });

                    myIdentify._mapSgs.map.on('singleclick', async (e) => { await myIdentify._mapSgs.tooltips.BuildInfoTooltips(e); });

                    $('#target-gpi-identifier').removeClass('button-selected');

                }, 500);

            

        });
        

    }

    // -- end public method -----------------------------------------------------------------------

    /**
     * Get Layers Intersect
     * @param {any} layerName
     * @param {any} cqlFilter
     * @param {any} newfeature
     * @param {any} searchresult
     */
    this.getAllObjectsonIntersect = function (layerName, cqlFilter, getFeatureUrl, idLayer) {

        layerIDhash = idLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: false, //ATENÇÃO está false para que consigamos saber o nome da layer que realizamos o ajax. se tivesse a true, não conseguiriamos saber a quem pertencia o resultado
            url: getFeatureUrl + '/wfs',
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeName": layerName,
                "cql_filter": cqlFilter,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, settings) {
            if (data.features) {
                if (data.features.length > 0) {

                    for (var i = 0; i < data.features.length; i++) {
                        myIdentify.layersToHighligth.push((new GeoJSON()).readFeatures(data)[i]);
                    }

                    myIdentify.countTotalFeatures += data.features.length;

                    $('#id-search-result-detail-info-number-result span')[0].innerHTML = myIdentify.countTotalFeatures;

                    hashlayerNameidentify[layerIDhash].result = data;

                    myIdentify.CreateDatatables(hashlayerNameidentify[layerIDhash].pretty_name, data, hashlayerNameidentify[layerIDhash].id)

                }

            } else {
                if (newfeature)
                    toastr["warning"]("Nenhuma camada encontrada");
                myIdentify._mapSgs._utility.ShowWait('spinner-search-anacom', false);
            }
        });
    }

    /**
    * Create Dinamic datatables
    * @param {any} NameLayer
    * @param {any} ListLayers
    * @param {any} idLayer
    */
    this.CreateDatatables = function (NameLayer, ListLayers, idLayer) {

        if (ListLayers.features.length > 0) {

            $('#offcanvas-search-result-network-table-zone').append('<div id="offcanvas-' + idLayer + '" class= "row mCustomScrollbar padding-fix extra-padding div-datatable-network" data-mcs-axis="yx" data-mcs-theme="rounded-dark"> ' +
                '<label id="label-' + idLayer + '" class="networkSearchDatatable">' + NameLayer + '</label>' +
                '<i class= "fa fa-expand networksearchExpand"></i> <div style="display: none;" id="div-' + idLayer + '">' +
                '<table id="table-' + idLayer + '" class="display Layer-' + idLayer + '" cellspacing="0" width="100%"></table></div ></div > ');

            $('#id-offcanvas-search-result-body').css('display', 'block');

            $('#offcanvas-search-result-table-zone').css('display', 'none');

            var feature = null;
            var layerName = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
            var workspace = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.workspace;
            var columnDefArray = [];
            var columDefArrayExpand = [];
            var columDefArrayExpandSize = [];
            var columnValueArray = [];
            var idPrimaryKey = null;
            var featureHash = {};
            for (let i = 0; i < ListLayers.features.length; i++) {
                feature = (new GeoJSON()).readFeatures(ListLayers)[i];
                idPrimaryKey = feature.getId().split(".")[1];
                myIdentify.featuresArray.push(feature);
                //featureHash[idPrimaryKey] = feature;

                // Save feature Search
                myIdentify._mapSgs._arraySearchLayerFeatureActive.push(feature);

                // Build column info
                var objRow = {};
                for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                    var columnName = Object.keys(feature.getProperties())[j];
                    if (columnName === "geometry")
                        continue;
                    var value = feature.getProperties()[columnName];
                    var columnProperties = myIdentify._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                        return obj.column_name === columnName
                    })[0];

                    // If value is a system date, format string
                    //if (new Date(value) != 'Invalid Date' && isNaN(value))
                    if (columnProperties) {
                        if (columnProperties.column_type == 'xsd:date-time')
                            value = app.sgs._utility.TransformDateServerInDateTime(value);

                        objRow[columnName] = value;
                        if (columDefArrayExpandSize[columnName]) {
                            if (value) {
                                var valueSize = value.toString().length;
                                columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                            }
                        }
                        else {
                            if (value)
                                columDefArrayExpandSize[columnName] = value.toString().length;
                            else
                                columDefArrayExpandSize[columnName] = 30; // If fist empty
                        }
                        if (i === 0) {
                            var columnSearchResult = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                            var visible = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                            var columnPrettyName = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                            var searchResultOrder = myIdentify._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                            if (columnSearchResult) {
                                columnDefArray.push({
                                    'data': columnName,
                                    'title': columnPrettyName,
                                    'name': columnPrettyName,
                                    'label': columnPrettyName,
                                    'type': columnPrettyName,
                                    'orderable': false,
                                    'width': '30px',
                                    'search_order': searchResultOrder
                                });
                            } else {
                                columnDefArray.push({
                                    'data': columnName,
                                    'type': 'readonly',
                                    'visible': false,
                                    'search_order': 0
                                });
                            }
                            if (visible) {
                                columDefArrayExpand.push({
                                    'data': columnName,
                                    'title': columnPrettyName,
                                    'name': columnPrettyName,
                                    'label': columnPrettyName,
                                    'type': columnPrettyName,
                                    'orderable': false,
                                    'width': '30px'
                                });
                            }
                            else {
                                columDefArrayExpand.push({
                                    'data': columnName,
                                    'type': 'readonly',
                                    'visible': false
                                });
                            }
                        }
                    }
                }
                // Order columns by search order
                columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                // Add primary key value
                objRow["id_primary_key"] = idPrimaryKey;

                // Add array row
                columnValueArray.push(objRow);
            }

            // Add primary key to array
            columnDefArray.push({
                'data': "id_primary_key",
                'type': 'readonly',
                'visible': false
            });

            // Add size to column in array expand
            for (let i = 0; i < columDefArrayExpand.length; i++) {
                var objDef = columDefArrayExpand[i];
                if (objDef.width) {
                    if (columDefArrayExpandSize[objDef.data] > 50)
                        objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                    else
                        objDef.width = "50px";
                    columDefArrayExpand[i] = objDef;
                }
            };

            // Show canvas search result
            myIdentify._mapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);

            // Make datatable list
            myIdentify.InitSearchResultTable(workspace, layerName, myIdentify._mapSgs.layerTree.selectedLayerSearch, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myIdentify._mapSgs.DetailElement, /*$.trim(NameLayer).replaceAll(' ', '')*/ idLayer );

            // Remove hide in offcanvas search result information
            $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
            //$('#id-offcanvas-search-result-body').removeClass('ol-hidden');
            myIdentify._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        }


    }

    /**
     * Init search result table
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {int} idLayer, layer id
     * @param {object} featureHash, feature
     * @param {array} columnDefArrayInput, array of column
     * @param {array} columDefArrayExpandInput, array of column for expand table
     * @param {array} columnValueArray, array of value
     * @param {function} gotoEntityDetailCallback, goto entity callback function
     */
    this.InitSearchResultTable = function (worksapce, layerName, idLayer, featureHash, columnDefArrayInput, columDefArrayExpandInput, columnValueArray, gotoEntityDetailCallback, idDatatable) {
        var columnDefArray = columnDefArrayInput;
        myIdentify._columnDefArrayExpand[idDatatable] = columDefArrayExpandInput;

        // Go to detail
        var objDef = {
            'name': 'button_goto_detail',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-column',
            'defaultContent': '<a class="button-goto-detail-search-result-network" title="Ir para o detalhe do elemento"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
            'width': '10%'
        };
        columnDefArray.unshift(objDef);

        // Goto to location
        objDef = {
            'name': 'button_goto_location',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-column',
            'defaultContent': '<a class="button-goto-location-search-result-network" title="Ir para a posição do elemento"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
            'width': '10%'
        };
        columnDefArray.unshift(objDef);

        var idRow = "id_primary_key";

        // -- Table search result -----------------------------------------------------------------

        // Destroy if exists
        if (myIdentify._mapSgs.datatableSearchResult != null) {
            // Destroy mCustomScrollbar
            //$('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            myIdentify._mapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // -- Table definition --
        $('#table-' + idDatatable).DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento'
            },
            "fixedHeader": true,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "data": columnValueArray,
            "select": false,
            "name": "search_result",
            "rowId": idRow,
            "columnDefs": [
                { "width": "10%", "targets": 0 },
                { "width": "10%", "targets": 1 },
                { "width": "10%", "targets": 2 }
            ],
            "initComplete": function (settings, json) {

                $('.button-goto-detail-search-result-network').unbind("click");
                $('.button-goto-location-search-result-network').unbind("click");
                $('.networkSearchDatatable').unbind("click");
                $('.networksearchExpand').unbind("click");

                // Goto element detail
                $('.button-goto-detail-search-result-network').on('click', function () {

                    var id = $(this).parent().parent()[0].id;

                    var features = myIdentify.featuresArray.filter(c => c.id_ == hashlayerNameidentify[$(this.closest('table')).attr('class').split(' ')[1].split('Layer-')[1]].layerName + "." + id);

                    var featuresSimulation = null;

                    // Get info element element
                    var featureInfo = null;
                    if (features.length > 0)
                        featureInfo = {
                            id: id,
                            layer_name: $(this.closest('table')).attr('class').split(' ')[1].split('Layer-')[1],
                            idLayer: this.closest('table').id.split('-')[1],
                            feature: features[0],
                            mode: 'read',
                            fromMap: false
                        };
                    else if (features.length > 0)
                        featureInfo = {
                            id: id,
                            layer_name: $(this.closest('table')).attr('class').split(' ')[1].split('Layer-')[1],
                            idLayer: this.closest('table').id.split('-')[1],
                            feature: features[0],
                            mode: 'read',
                            fromMap: false
                        };
                    else if (myIdentify._resultRefDataSearch)
                        featureInfo = {
                            id: id,
                            layer_name: $(this.closest('table')).attr('class').split(' ')[1].split('Layer-')[1],
                            idLayer: this.closest('table').id.split('-')[1],
                            mode: 'read',
                            fromMap: false
                        };

                    // Set Detail
                    if (featureInfo)
                        gotoEntityDetailCallback(featureInfo);
                });

                // Goto element search in map 
                $('.button-goto-location-search-result-network').off('click').on('click', function (e) {

                    e.preventDefault();

                    var LayerNameByClass = $(this.closest('table')).attr('class').split(' ')[1];

                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = hashlayerNameidentify[LayerNameByClass.split('Layer-')[1]].layerName + "." + id;


                    // Remove highlight
                    myIdentify._mapSgs.layerHighlightOverlay.getSource().clear();

                    //Go to event
                    myIdentify._mapSgs.SetFeaturesHighlightByArray(worksapce, hashlayerNameidentify[LayerNameByClass.split('Layer-')[1]].layerName, false, [idFeature]);

                    var VerifyClass = $('#id-search-result-detail-info-number-result').hasClass('hide-highlight');

                    if (!VerifyClass)
                        $('#id-search-result-detail-info-number-result').addClass('hide-highlight');

                });

                // Open/Close datatable
                $('.networkSearchDatatable').off('click').on('click', function () {

                    if (this.id.split('label-')[1] != "") {

                        if ($('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').is(':visible'))
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'none');
                        else
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'block');
                    }
                });

                // Open/Close datatable
                $('.networksearchExpand').on('click', function () {

                    var featuresProperties = $(hashlayerNameidentify[$(this).siblings('label')[0].id.split('-')[1]].result.features).map(function () { return this.properties });

                    myIdentify.InitSearchResultTableExtend(null, null, null, featuresProperties, myIdentify._columnDefArrayExpand[$(this).siblings('label')[0].id.split('-')[1]]);

                });

                myIdentify._mapSgs.tooltips._navisionTool.getAllClientByPredio('button-goto-webservice-network');

            }
        });

    }

    /**
     * Init search result extend table
     * @param {any} worksapce
     * @param {any} layerName
     * @param {any} idLayer
     * @param {any} columnValueArray
     * @param {any} columnDefArrayExpand
     */
    this.InitSearchResultTableExtend = function (worksapce, layerName, idLayer, columnValueArray, columnDefArrayExpand) {

        // -- Table search result expand ----------------------------------------------------------

        // Destroy if exists
        if (myIdentify._mapSgs.datatableSearchResultExpand != null) {

            // Destroy table
            myIdentify._mapSgs.datatableSearchResultExpand.destroy();

        }

        // Empty table zone
        $('#offcanvas-map-list-search-result-table-zone').empty();

        // Recreate table node
        var tableSearch = $('<table id="offcanvas-map-list-search-result-table" cellspacing="3" width="100%" style="white-space: nowrap;"></table>');
        tableSearch.appendTo($('#offcanvas-map-list-search-result-table-zone'));
        //}

        // -- Table definition --
        $('#offcanvas-map-list-search-result-table').DataTable({
            "dom": '<"top"ifp>rt',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento'
            },
            //"fixedHeader": false,
            "info": false,
            "scrollY": $('#offcanvas-map-list-search-result-table-zone').height() - 80,
            "scrollX": true,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": true,
            "paging": true,
            "ordering": false,
            "columns": columnDefArrayExpand,
            "data": columnValueArray,
            "select": false,
            "name": "search_result_expand"
        });

        // Show canvas search result
        myIdentify._mapSgs._utility.ShowOpenCanvas3('offcanvas-map-list', true);
        $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

    }

    // -- begin private method --------------------------------------------------------------------
    // -- end private method ----------------------------------------------------------------------
};

/**
 * Init identify information
 * @param {ol.map} map, ol map
 */
Identify.prototype.InitIdentify = function (MapSgs) {

    // Keep map sgs
    this._mapSgs = MapSgs;
};
